// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"blockquote_blockquote__o2icA","blockquoteText":"blockquote_blockquoteText__B2R65"};